import { Carousel, Mobile } from '../core'
import Fancybox from '@fancyapps/fancybox'

$.mlmi = {
  mobile: new Mobile(),
}

$.fn.GalleryGrid = function() {
  let self = this
  self.carousel = undefined

  return function() {
    self.carousel = new Carousel(self.find('.swiper-container').get(0), {
      slidesPerView: 'auto',
      spaceBetween: 14,
      calculateHeight: true,
      freeMode: true,
      freeModeFluid: true,
      autoHeight: false,
      snapOnRelease: false,
      loop: false,
      //mousewheel: true,
      // scrollbar : {
      //   el: self.find('.media-grid__gallery__navigation .swiper-scrollbar').get(0),
      //   draggable: true,
      // },
      navigation: {
        prevEl: self.find('.carousel__toolbar .swiper-button-prev').get(0),
        nextEl: self.find('.carousel__toolbar .swiper-button-next').get(0),
      },
    }, {
      forceRebuild: true,
      onBeforeInit: function() {
        if($.mlmi.mobile.isMobile){
          self.find('.media-grid__slide__element').unwrap().wrap( "<li class='media-grid__slide swiper-slide'></li>" );
        }else{
          self.find('.media-grid__slide__element').unwrap();
          var max_slides = self.find('.media-grid__slide__element:last-child').attr('data-desktop-slide');
          for (var i = 0; i <= max_slides; i++) {
            self.find('[data-desktop-slide="' + i + '"]').wrapAll( "<li class='media-grid__slide swiper-slide'></li>" );
          }
        }
      },
    });
    self.carousel.init()
    return self
  }()
}

/* Initialization */
$('.js-media-grid-wrapper').each(function(index) {
  $(this).GalleryGrid();

  $(this).find('[data-fancybox="gallery"]').attr('data-fancybox', 'gallery_' + index);
  $('[data-fancybox="gallery_' + index + '"]').fancybox({
    loop: true,
    animationEffect: "fade",
    backFocus: false,
    buttons: ['close'],
    btnTpl: {
      close: '<button data-fancybox-close="" class="fancybox-button fancybox-button--close" title="Close"><i class="icon-close"></i></button>',
      arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><i class="icon-angle"></i></button>',
      arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><i class="icon-angle"></i></button>',
    },
    baseTpl:
      '<div class="fancybox-container" role="dialog" tabindex="-1">' +
      '<div class="fancybox-bg"></div>' +
      '<div class="fancybox-inner">' +
      '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
      '<div class="fancybox-toolbar">{{buttons}}</div>' +
      '<div class="fancybox-navigation">{{arrows}}</div>' +
      '<div class="fancybox-stage"></div>' +
      '</div>' +
      '</div>',
    afterLoad : function(fb, item){
      item.$content.remove('.fb-caption').append('<div class="fb-caption">' + item.opts.caption + '</div>');
    }
  });
})
